import SeatIconState from './SeatIconState';
import CharacterIcons from './CharacterIcons';
import Icons from './Icons';
import Badges from './Badges';
import SeatIcon from './SeatIcon';
import GraphicType from '../api/GraphicType';

/**
 * @param {string} iconCharacter
 * @param {string} graphicType
 */
function build(iconCharacter, graphicType) {
  let defaultState;
  let selectedState;

  if (graphicType === GraphicType.EmptySet) {
    defaultState = new SeatIconState(Icons.EmptySet);
  }

  if (graphicType === GraphicType.Square) {
    defaultState = new SeatIconState(Icons.Square);
  }

  if (graphicType === GraphicType.Circle) {
    const icon = CharacterIcons.getCharacterIcon(iconCharacter);

    defaultState = new SeatIconState(icon);
    selectedState = new SeatIconState(Icons.Donut);
  }

  if (graphicType === GraphicType.Wheelchair) {
    const icon = CharacterIcons.getCharacterIcon(iconCharacter);
    const badge = Badges.Wheelchair;

    defaultState = new SeatIconState(icon, badge);
    selectedState = new SeatIconState(Icons.Donut, badge);
  }

  if (graphicType === GraphicType.Star) {
    const icon = CharacterIcons.getCharacterIcon(iconCharacter);
    const badge = Badges.Star;

    defaultState = new SeatIconState(icon, badge);
    selectedState = new SeatIconState(Icons.Donut, badge);
  }

  return new SeatIcon(defaultState, selectedState);
}

export default {
  build,
};
